import type {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  InvitationValidationResponse,
  LoginRequest,
  LoginResponse,
  SessionResponse,
  ValidateInvitationRequest,
} from '../types/auth';
import { request } from './apiClient';

export function getSession(): Promise<SessionResponse> {
  return request<SessionResponse>('/api/auth/session');
}

export function login(credentials: LoginRequest): Promise<LoginResponse> {
  return request<LoginResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
}

export function logout(): Promise<void> {
  return request('/api/auth/logout', { method: 'POST', expectNoContent: true });
}

export function validateInvitation(token: string): Promise<InvitationValidationResponse> {
  const payload: ValidateInvitationRequest = { token };

  return request<InvitationValidationResponse>('/api/auth/invitations/validate', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function acceptInvitation(
  invitation: AcceptInvitationRequest,
): Promise<AcceptInvitationResponse> {
  return request<AcceptInvitationResponse>('/api/auth/invitations/accept', {
    method: 'POST',
    body: JSON.stringify(invitation),
  });
}
